import React from "react";
import { useTranslation } from "react-i18next";
import GalleryRectangle from "../Components/Gallery/galleryRectangle";

const GalleryPage = () => {
  const { t } = useTranslation();

  return (
    <div>
      <GalleryRectangle />
    </div>
  );
};

export default GalleryPage;
